import styled from 'styled-components';
import { PropertyCardPhotoHeaderMixin } from '../../mixins/components/PropertyCardPhotoHeaderMixin';
export var StyledPropertyCardPhotoHeader = /*#__PURE__*/styled.div.withConfig({
  displayName: "StyledPropertyCardPhotoHeader",
  componentId: "c11n-8-111-1__sc-4wdzry-0"
})(["", ""], PropertyCardPhotoHeaderMixin);